<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Gestão de Unidade") }}</h1>

        <div class="row m-2">
            <b-card class="shadow col-md-12">
                <template v-slot:default>
                    <loading-animation
                        :active.sync="loading"
                        :is-full-page="false"
                        :opacity="1"
                        color="#5895FF"
                    />
                    <ul class="nav nav-tabs">
                        <li>
                            <a
                                href="#"
                                @click.prevent="page = 'detalhes'"
                                :class="page == 'detalhes' ? 'active' : ''"
                            >
                                Detalhes
                            </a>
                        </li>
                        <li>
                            <a
                                href="#"
                                @click.prevent="page = 'tecnicos'"
                                :class="page == 'tecnicos' ? 'active' : ''"
                            >
                                Técnicos
                            </a>
                        </li>
                        <li>
                            <a
                                href="#"
                                @click.prevent="page = 'abrangencia'"
                                :class="page == 'abrangencia' ? 'active' : ''"
                            >
                                Abrangência
                            </a>
                        </li>
                        <li>
                            <a
                                href="#"
                                @click.prevent="page = 'logotipo'"
                                :class="page == 'logotipo' ? 'active' : ''"
                            >
                                Logotipo/Brasão
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content mt-3">
                        <div
                            class="tab-pane"
                            :class="page == 'detalhes' ? 'active' : ''"
                            v-if="page == 'detalhes'"
                        >
                            <div v-if="historicoStatus == false">
                                <form
                                    @submit.prevent="editUnidade"
                                    ref="addItem"
                                >
                                    <div class="row">
                                        <b-form-group
                                            class="mb-2 col-md-12"
                                            label-for="nome_tipo_unidade"
                                        >
                                            <label for="nome_tipo_unidade">
                                                <strong
                                                    >{{ $t("Tipo da Unidade") }}
                                                    <span class="text-danger"
                                                        >*</span
                                                    >
                                                </strong>
                                            </label>
                                            <v-select
                                                label="nome_tipo_unidade"
                                                :filterable="true"
                                                :options="tiposUnidadesList"
                                                @search="onSearch"
                                                v-model="item.nome_tipo_unidade"
                                                placeholder="Pesquise o Tipo da Unidade. Ex.: CRAS, CREAS, CENTRO POP..."
                                                disabled
                                            >
                                                <template slot="no-options">
                                                    Digite o nome do tipo que
                                                    deseja localizar. Ex.: CRAS,
                                                    CREAS, CENTRO POP...
                                                </template>
                                                <template
                                                    slot="option"
                                                    slot-scope="option"
                                                >
                                                    <div class="d-center">
                                                        {{
                                                            option.nome_tipo_unidade
                                                        }}
                                                    </div>
                                                </template>
                                                <template
                                                    slot="selected-option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="selected d-center"
                                                    >
                                                        {{
                                                            option.nome_tipo_unidade
                                                        }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </b-form-group>
                                        <form-select
                                            v-if="
                                                (item.nome_tipo_unidade &&
                                                    item.nome_tipo_unidade
                                                        .nome_tipo_unidade ==
                                                        'UA - UNIDADE ACOLHIMENTO') ||
                                                item.nome_tipo_unidade ==
                                                    'UA - UNIDADE ACOLHIMENTO'
                                            "
                                            v-model="item.subtipo_id"
                                            :itens="subtiposAcolhimento"
                                            label="Subtipos"
                                        />
                                        <form-input
                                            v-model="item.nome"
                                            grid="12"
                                            label="Nome"
                                            :required="true"
                                        />
                                    </div>
                                    <div
                                        class="row"
                                        v-if="
                                            item.nome_tipo_unidade ==
                                            'UE - UNIDADE EXTERNA'
                                        "
                                    >
                                        <div class="col-md-12">
                                            <b-link
                                                href="#"
                                                @click.prevent="
                                                    showUnidadeExterna = false
                                                "
                                                v-if="showUnidadeExterna"
                                                >Mostrar campos extras</b-link
                                            >
                                            <b-link
                                                v-else
                                                href="#"
                                                @click.prevent="
                                                    showUnidadeExterna = true
                                                "
                                                >Esconder campos extras</b-link
                                            >
                                        </div>
                                    </div>

                                    <div class="row" v-if="!showUnidadeExterna">
                                        <form-input
                                            v-model="item.email"
                                            grid="6"
                                            label="E-mail"
                                            :required="true"
                                        />

                                        <form-input
                                            v-model="item.telefone"
                                            grid="6"
                                            label="Telefone(s)"
                                            :required="true"
                                            placeholder="Telefone(s) da Unidade"
                                        />

                                        <form-input
                                            v-model="item.razao_social"
                                            grid="6"
                                            label="Razão Social"
                                        />

                                        <form-input
                                            v-model="item.cnpj"
                                            grid="6"
                                            label="CNPJ"
                                            v-mask="'##.###.###/####-##'"
                                            placeholder="00.000.000/0000-00"
                                        />

                                        <form-input
                                            v-model="item.cadsuas"
                                            grid="4"
                                            label="Número CADSUAS"
                                            ajuda="O CadSUAS é o sistema de Cadastro do SUAS (Sistema Único de Assistência Social), instituído pela Portaria nº 430, de 3 de dezembro de 2008 e  nele são registradas todas as informações cadastrais de prefeituras, unidades gestoras, fundos, conselhos municipais, rede socioassistencial e trabalhadores do SUAS."
                                        />

                                        <form-input
                                            v-model="item.cneas"
                                            grid="4"
                                            label="Número CNEAS"
                                            ajuda="Como saber o número do Cneas?
	A Consulta do CNEAS pode ser acessada pela área de Assistência Social do site do MDS (www.mds.gov.br/assuntos/assistencia-social) ou diretamente no endereço (http://aplicacoes.mds.gov.br/cneas/publico/xhtml/consultapublica/pesquisar.jsf)."
                                        />

                                        <form-input
                                            v-model="item.cmas"
                                            grid="4"
                                            label="Número CMAS"
                                            ajuda="O Conselho Municipal de Assistência Social - CMAS é o órgão que reúne representantes do governo e da sociedade civil para discutir, estabelecer normas e fiscalizar a prestação de serviços sociais públicos e privados no Município."
                                        />

                                        <form-input
                                            v-model="item.expediente"
                                            grid="6"
                                            label="Expediente"
                                            v-mask="'##:## às ##:##'"
                                            placeholder="Exemplo: 07:00 às 16:00"
                                        />

                                        <form-input
                                            v-model="item.site"
                                            grid="6"
                                            label="Site"
                                        />
                                    </div>

                                    <div v-if="item.tecnicos">
                                        <form-endereco
                                            :item="item.endereco"
                                            v-if="!showUnidadeExterna"
                                        />
                                    </div>

                                    <div class="row" v-if="item.tecnicos">
                                        <form-textarea-editor
                                            v-model="item.observacoes"
                                            label="Observação"
                                        />
                                    </div>

                                    <div class="row">
                                        <form-select
                                            @change="verificarStatus"
                                            v-model="item.status"
                                            label="Status"
                                            grid="4"
                                            :itens="status"
                                        />

                                        <form-file
                                            grid="8"
                                            @submit="submitFile"
                                            multiple
                                            btn-text="Iniciar"
                                            :progress="progressCompleted"
                                        />
                                    </div>
                                    <div class="row d-flex justify-content-end">
                                        <div class="col-md-auto px-2">
                                            <div class="float-right mt-3">
                                                <a
                                                    class="router-link-exact-active active px-3"
                                                    @click="
                                                        historicoStatus = true
                                                    "
                                                >
                                                    <i
                                                        class="fas fa-history"
                                                    ></i>
                                                    Histórico de Status
                                                </a>

                                                <router-link
                                                    v-b-tooltip.hover
                                                    title="Voltar para Unidades"
                                                    class="btn btn-default"
                                                    to="/dashboard/unidades"
                                                >
                                                    <i
                                                        class="mdi mdi-arrow-left"
                                                    ></i>
                                                </router-link>

                                                <button
                                                    class="btn btn-success btn-submit"
                                                    data-style="zoom-in"
                                                    type="submit"
                                                >
                                                    <i
                                                        class="mdi mdi-content-save"
                                                    />
                                                    {{ $t("Salvar") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <div v-if="item.anexos">
                                    <anexos :anexos="item.anexos" />
                                </div>
                            </div>

                            <div class="row" v-else>
                                <div class="col-12">
                                    <h4 class="font-weight-bold">
                                        Gestão de Unidade
                                    </h4>
                                </div>
                                <HistoricoStatus
                                    @voltar="historicoStatus = false"
                                    :id="item.id"
                                    :familia="0"
                                    :status="status_item"
                                />
                            </div>
                        </div>
                        <div
                            class="tab-pane"
                            :class="page == 'tecnicos' ? 'active' : ''"
                            v-if="page == 'tecnicos'"
                        >
                            <TecnicosUnidades />
                        </div>

                        <div
                            class="tab-pane"
                            :class="page == 'abrangencia' ? 'active' : ''"
                            v-if="page == 'abrangencia'"
                        >
                            <Abrangencia />
                        </div>
                        <div
                            class="tab-pane"
                            :class="page == 'logotipo' ? 'active' : ''"
                            v-if="page == 'logotipo'"
                        >
                            <LogotipoBrasao :item="item" />
                        </div>
                    </div>

                    <AddTecnico v-if="page == 'tecnicos_add'" />
                    <EditTecnico
                        v-if="page == 'tecnicos_edit'"
                        :tecnico="tecnico_id"
                    />
                </template>
            </b-card>
        </div>
        <status-historico
            :model="model"
            modulo="Unidade"
            titulo_modulo="UNIDADE"
            :id="item.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_item"
            @submit="editUnidade"
        />
    </div>
</template>

<script>
import TecnicosUnidades from "./includes/tecnicos/ReadTecnicos";
import AddTecnico from "./includes/tecnicos/AddTecnico";
import EditTecnico from "./includes/tecnicos/EditTecnico";
import Abrangencia from "./includes/Abrangencia";
import LogotipoBrasao from "./includes/LogotipoBrasao";
import HistoricoStatus from "./HistoricoStatus";

export default {
    name: "Edit",
    components: {
        TecnicosUnidades,
        Abrangencia,
        LogotipoBrasao,
        AddTecnico,
        EditTecnico,
        HistoricoStatus,
    },
    data() {
        return {
            files: {},
            loading: true,
            tiposUnidadesList: [],
            subtiposAcolhimento: [],
            localidades: [],
            localidade: {},
            logradouros: [],
            logradouro: {},
            item: {},
            page: "detalhes",
            localidade_bairro: "",
            logradouro: "",
            loadingLocalidade: false,
            loadingLogradouros: false,
            tecnico_id: null,
            model: "Unidade",
            status: {},
            status_item: [],
            statusAtual: "",
            statusAnterior: "",
            historicoStatus: false,
            progressCompleted: 0,
            showUnidadeExterna: false,
        };
    },
    mounted() {
        this.getStatus();
        this.getUnidade();
        this.getSubtipos();
        this.getStatusFinais();
        this.$root.$on("pageSelect", (data) => {
            this.page = data;
        });
    },
    methods: {
        getSubtipos() {
            axios.get("api/dashboard/unidades/getsubtipos").then((response) => {
                this.subtiposAcolhimento = response.data;
            });
        },
        submitFile(files) {
            this.files = files;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            let formData = new FormData();
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }

            formData.append("id", this.$route.params.id);

            // Send request
            axios
                .post(`api/dashboard/admin/unidade/${this.$route.params.id}/upload`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                    this.getUnidade();
                });
        },
        getUnidade() {
            axios
                .get("api/dashboard/unidades/" + this.$route.params.id)
                .then((response) => {
                    this.item = response.data.data;
                    // this.logradouros = this.setSelected(this.item.nome_localidade);

                    // this.localidade_bairro = this.item.nome_localidade.nome_localidade;
                    // this.logradouro = this.item.nome_logradouro.nome_logradouro;
                    this.item.nome_tipo_unidade == "UE - UNIDADE EXTERNA"
                        ? (this.showUnidadeExterna = true)
                        : (this.showUnidadeExterna = false);

                    this.statusAnterior = this.item.status;
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        getStatus() {
            axios.get(`api/dashboard/status/unidades`).then((response) => {
                this.status = response.data;
            });
        },
        verificarStatus(status) {
            this.statusAtual = status;

            const result = this.status_item.filter((item) => item.id == status);
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: this.model,
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        editUnidade() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            // Send request
            axios
                .put(`api/dashboard/admin/unidades/${this.item.id}`, this.item)
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                });
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            axios
                .get(`api/dashboard/tipounidade/pesquisar?q=${escape(search)}`)
                .then((response) => {
                    this.tiposUnidadesList = response.data;
                    loading(false);
                });
        },

        deleteUnidade() {
            if (this.item.tecnicos.length > 0) {
                swal.fire({
                    icon: "error",
                    title: "Não é possível excluir a unidade!",
                    text: "Está unidade possui tecnicos vinculados, portanto não poderá ser excluída.",
                    showConfirmButton: false,
                });
            } else {
                swal.fire({
                    title: this.$t("Are you sure?"),
                    showCancelButton: true,
                    cancelButtonText: this.$t("Cancel"),
                    confirmButtonText: this.$t("Delete"),
                    icon: "warning",
                }).then((value) => {
                    if (value) {
                        this.loading = true;
                        axios
                            .delete("api/dashboard/admin/unidades/" + this.item.id)
                            .then((response) => {
                                this.$snack.success({
                                    button: false,
                                    text: response.data.data.message,
                                });
                                this.$router.push("/dashboard/unidades");
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    }
                });
            }
        },
    },
};
</script>

<style>
.vs__clear {
    display: none !important;
}
</style>
